module.exports = __webpack_public_path__ + "img/go west.e6babfe4.png";